import type React from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';
interface HelpProps extends React.SVGProps<SVGSVGElement> {}
const _Help = (props: HelpProps) => <svg aria-hidden="true" fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props} className={cn('size-4', props.className)} data-sentry-element="svg" data-sentry-component="_Help" data-sentry-source-file="Help.tsx">
    <path d="M4.6665 4.98268C4.6665 4.98268 5.21717 2.40668 7.47517 2.05734C9.5325 1.73934 11.7052 2.74801 11.7425 4.98268C11.7738 6.81401 9.0145 8.06468 8.3905 9.23468C8.1425 9.70001 8.1505 11.046 8.1505 11.046" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.33" data-sentry-element="path" data-sentry-source-file="Help.tsx" />
    <ellipse cx="8.16813" cy="13.8867" fill="currentColor" rx="0.666667" ry="0.666667" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="0.5" data-sentry-element="ellipse" data-sentry-source-file="Help.tsx" />
  </svg>;
const Help = memo(_Help);
export const HelpWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="HelpWithIconTag" data-sentry-source-file="Help.tsx">
    <Help className={className} data-sentry-element="Help" data-sentry-source-file="Help.tsx" />
  </i>;
export default Help;